export default __webpack_public_path__ + "static/media/diners.b623f45b.jpg";